import styled, { keyframes } from "styled-components";
import { motion } from "framer-motion";

const showLayout = keyframes`
    0% {background-color: rgba($color: #000000, $alpha: 0);}
    100% {background-color: rgba($color: #000000, $alpha: 0.4);}
`;

const hideLayout = keyframes`
    0% {background-color: rgba($color: #000000, $alpha: 0.4);}
    100% {background-color: rgba($color: #000000, $alpha: 0);}
`;

const showModal = keyframes`
    0% {opacity: 0;}
    40% {opacity: 0;}
    100% {opacity: 1;}
`;

const hideModal = keyframes`
    0% {opacity: 1;}
    100% {opacity: 0;}
`;

export const StyledOverlay = styled.div`
  animation: ${showLayout} 1s forwards;
  position: ${(props: any) => props.style.position};
  width: ${(props: any) => props.style.width};
  height: ${(props: any) => props.style.height};
  display: flex;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  z-index: 10;
  background: #00000080;
  transition: 0.3s all;

  &.fadeout {
    animation: ${hideLayout} 0.3s forwards;
  }
` as any;

export const StyledModalBorder = styled.div`
  animation: ${showModal} 0.6s forwards;
  opacity: 0;
  max-width: 400px;
  width: 90%;
  padding: 5px;
  border-radius: 30px;
  background: linear-gradient(
    180deg,
    ${(props: any) => props.colorOne} 0%,
    ${(props: any) => props.colorTwo} 100%
  );

  &.fadeout {
    animation: ${hideModal} 0.3s forwards;
  }
` as any;

export const StyledModal = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 20px;
  padding-top: 60px;
  border-radius: 24px;
  background: linear-gradient(
    180deg,
    ${(props: any) => props.colorOne} 0%,
    ${(props: any) => props.colorTwo} 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: ${(props: any) => props.fontFamily};

  .closeButton {
    position: absolute;
    cursor: pointer;
    top: 20px;
    left: 15px;
    height: 32px;
  }

  h2 {
    margin: 0;
    margin-bottom: 16px;
    background: linear-gradient(
      180deg,
      ${(props: any) => props.headerColorOne} 0%,
      ${(props: any) => props.headerColorTwo} 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  h5 {
    margin-top: 0;
    margin-bottom: 20px;
    text-align: center;
  }

  img.button,
  button {
    height: 60px;
    width: 100%;
    cursor: pointer;
  }
` as any;
